import React from 'react';
import PropTypes from 'prop-types';

import { Spinner } from '@mssgme/ui';

import styles from './ImageUploadAvatar.scss';

export default function ImageUploadAvatar({ className, accept, name, onChange, buttonLabel, previewUrl, isUploading }) {
    return (
        <div className={className}>
            <div className={styles.root}>
                <div className={styles.avatarPreview}>
                    <img src={previewUrl} alt="Avatar" />
                </div>
                <div className={styles.button}>
                    {isUploading && <Spinner size={16} color="black" />}
                    {!isUploading && (
                        <>
                            {buttonLabel}
                            <input
                                type="file"
                                className={styles.fileInput}
                                accept={accept}
                                name={name}
                                onChange={onChange}
                            />
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

ImageUploadAvatar.propTypes = {
    className: PropTypes.string,
    name: PropTypes.string.isRequired,
    accept: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    previewUrl: PropTypes.any.isRequired,
    isUploading: PropTypes.bool.isRequired,
    buttonLabel: PropTypes.string,
};

ImageUploadAvatar.defaultProps = {
    className: '',
    buttonLabel: 'Upload',
};
